import { styled } from 'styled-components'

export const IconButton = styled.button`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #8c8c8c;
  font-size: 14px;
  line-height: 1;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: help;
  transition: color 0.2s ease, background-color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: #1677ff;
    background-color: #e6f4ff;
    outline: none;
  }
`
